import { makeStyles } from "@material-ui/core/styles";

export default function CardNotaFiscal() {
    return makeStyles((theme) => ({
        itensCard: {
            overflow: "auto",
            margin: "5px",
            maxHeight: "200px",
        },
        rowCardNotaFiscal: {
            margin: "6px"
        },
        cardNotaFiscal: {
            width: "70%",
            margin: "auto",
            borderRadius: "10px",
            backgroundColor: theme.palette.secondary.background,
            alignItems: "center",
        },
    }));
}
